/** Публичные ссылки техподдержки Лиги (меню в App, экраны ошибок). */
export const SUPPORT_TELEGRAM_URL = 'https://t.me/+LU7nvmUqFBk2ZWJi';
export const SUPPORT_VK_URL = 'https://vk.me/join/k3MoMWZ12NbQA_Z3h7MeJOAB1/FMGsS3beE=';
